module.exports = __webpack_public_path__ + "static/media/look-board-view.ed8699a4.png";